module.exports = __webpack_public_path__ + "71f6684e463018a333311c8a232ea386.pdf";